export const KitVersionStatusEnum = [
  'VALIDATED',
  'NOT_VALIDATED',
  'PERF'
];